import { RouteName } from '@/constants/RouteName';
import type { AnalysisStep } from '@/types/analytics/AnalysisStep';

export const DATA: AnalysisStep = {
  name: RouteName.DATA,
  route: '/indices',
  disabled: false,
  substeps: [],
  icon: 'chart-scatter',
  mobileOnly: false,
  defaultSubstepPath: '',
};

export const FACTSHEET: AnalysisStep = {
  name: RouteName.FACTSHEET,
  route: '/factsheet',
  disabled: false,
  substeps: [],
  icon: 'file-lines',
  mobileOnly: false,
  defaultSubstepPath: '',
};
